<template>
    <svg
      class="tw-progress-ring"
      :width="shapeSize"
      :height="shapeSize"
      data-test="progress-ring-svg"
      >
    <circle
      class="tw-progress-ring-circle-bg"
      fill="transparent"
      :stroke-width="strokeWidth"
      :r="radius"
      :cx="center"
      :cy="center"
      data-test="progress-ring-circle-bg"
      />
    <circle
      class="tw-progress-ring-circle"
      fill="transparent"
      :stroke-width="strokeWidth"
      :stroke-dasharray="`${circumference} ${circumference}`"
      :stroke-dashoffset="offset"
      :r="radius"
      :cx="center"
      :cy="center"
      data-test="progress-ring-circle"
      />
    </svg>
  </template>

  <script>
  export default {
    name: 'ProgressRing',
    props: {
      size: {
        type: Number,
        required: true,
      },
      progressPercent: {
        type: Number,
        required: true,
      },
      strokeWidth: {
        type: Number,
        required: true,
      },
    },
    computed: {
      shapeSize() {
        return this.size;
      },
      radius() {
        return (this.size / 2) - (this.strokeWidth * 2);
      },
      center() {
        return (this.size / 2) - (this.strokeWidth * 2);
      },
      circumference() {
        return this.radius * 2 * Math.PI;
      },
      offset() {
        return this.circumference - ((this.progressPercent / 100) * this.circumference);
      },
    },
  };
  </script>
